import { render, staticRenderFns } from "./PopupExport.vue?vue&type=template&id=0d008c28&scoped=true"
import script from "./PopupExport.vue?vue&type=script&lang=js"
export * from "./PopupExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d008c28",
  null
  
)

export default component.exports